// js
import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { Icons } from '@its-svp/svp-common-ui';
// css
import '../../styles/components/common/QuestionAccordion.scss';


const QuestionAccordion = ({
  title,
  itemsCompleteCount,
  itemsTotalCount,
  open,
  onToggle,
  children
}) => {

  const containerClasses = classnames({
    'accordion-container': true,
    'active': open
  });

  return (
    <div className='question-accordion'>
      <div className={containerClasses}>
        <div className='accordion-header' onClick={onToggle}>
          <div className='row header-row'>
            <div className='col-xs-9'>
              <label className='h5 accordion-title'>{title}</label>
            </div>
            <div className='col-xs-2'>
              <span className='question-accordion__complete-checkmark'>
                {itemsCompleteCount === itemsTotalCount && <Icons.CheckmarkSolid />}
              </span>
              <span className='question-accordion__complete-count'>
                {`${itemsCompleteCount}/${itemsTotalCount} Items Complete`}
              </span>
            </div>
            <div className='col-xs-1 text-center'>
              <div className='accordion-arrow' />
            </div>
          </div>
        </div>
        <div className='accordion-pane'>
          {children}
        </div>
      </div>
    </div>
  );
};

QuestionAccordion.propTypes = {
  title: PropTypes.string.isRequired,
  itemsCompleteCount: PropTypes.number.isRequired,
  itemsTotalCount: PropTypes.number.isRequired,
  open: PropTypes.bool,
  onToggle: PropTypes.func,
  children: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.arrayOf(PropTypes.element)
  ])
};

export default QuestionAccordion;



// WEBPACK FOOTER //
// ./src/components/common/QuestionAccordion.js